<template>
  <div class="notification">
    <Check v-if="isSuccess" class="icon success" />
    <Cross v-else class="icon error" />
    <div class="message" :class="isSuccess ? 'success' : 'error'" v-html="htmlMessage"></div>
  </div>
</template>

<script>
import Check from '@/assets/listing/check.svg';
import Cross from '@/assets/icons/cross.svg';
export default {
  name: 'NotificationComponent',
  components: {
    Check,
    Cross,
  },
  props: {
    isSuccess: {
      type: Boolean,
      default: true,
    },
    htmlMessage: {
      type: String,
      required: true,
    },
  },
  data: function () {
    return {};
  },
  computed: {},
  methods: {},
};
</script>

<style scoped lang="scss">
@use '@/styles/colors.scss';

$layout-breakpoint-small: 512px;

.notification {
  position: absolute;
  top: -8px;
  right: 282px;
  z-index: 10;
  display: flex;
  align-items: center;
  min-height: 34px;
  border-radius: 5px;
  background-color: colors.$white-color;
  box-shadow: 0 2px 4px 0 rgba(188, 188, 188, 0.5);
  padding: 5px;

  .icon {
    width: 22px;
    height: 22px;
    border-radius: 50%;
    color: colors.$white-color;
    padding: 4px;
    box-sizing: border-box;
    margin: 0 11px;
    flex-shrink: 0;

    &.error {
      padding: 0 1px 0 0;
      background-color: #e9022f;
    }

    &.success {
      background-color: #2d6470;
    }
  }
  .message {
    margin: 0 11px 0 0;
    font-size: 16px;
    font-weight: initial;

    &.error {
      color: #e9022f;
    }

    &.success {
      color: #2d6470;
    }
  }
}

@media screen and (max-width: $layout-breakpoint-small) {
  .notification {
    position: absolute;
    top: 123px;
    right: 15px;
    left: 15px;
    min-height: 26px;
    padding: 2px;

    .message {
      font-size: 9px;
    }
  }
}
</style>
